import Link from 'next/link';
import { useRouter } from 'next/router';
import { ArrowLeftIcon } from '@heroicons/react/outline';
import { BookCover } from '../../components/Guides/BookCover';
import { renderRichText } from '../../lib/blog';
import { Book } from '../../lib/guideBooks';
import { Routes } from '../../util/routes';

type Props = {
  book: Book;
};

export const BookContent = ({ book }: Props) => {
  const { query } = useRouter();
  const { title, contentCollection } = book;

  return <>
    <div className="inline-block self-start">
      <Link
        href={Routes.guides(query['company-slug'] as string)}
        className="nav-back flex items-center space-x-2 text-base font-semibold text-black/70 underline-offset-4 transition-colors hover:text-black/50 hover:underline">

        <ArrowLeftIcon className="icon" />
        <span>back to guides</span>

      </Link>
    </div>
    <div className="guide-book-headline my-10 flex flex-col space-y-4 md:flex-row md:items-center md:space-x-8">
      <BookCover book={book} className="flex-shrink-0 self-start" />
      <h1 className="h1 book-title">{title}</h1>
    </div>

    <div className="content">
      {contentCollection.items.map((chapter) => {
        return (
          <div key={chapter.title} className="mb-8" id={chapter.displayTitle}>
            <h4 className="h4 mb-4">{chapter.displayTitle}</h4>
            {renderRichText(
              chapter.content?.json,
              chapter.content?.links?.assets
            )}
          </div>
        );
      })}
    </div>
  </>;
};
